module.exports = __webpack_public_path__ + "img/(1).8386b297.jpg";